// feature/litisoft-mandatory-fields-v1 — sprint83.
//
// One-time announcement modal shown to users with the "abogado" role
// the first time they sign in after the LITISOFT-mandatory rollout.
//
// Mount: AppShell — fires for every authenticated route.
// Dismiss: POST /api/auth/dismiss-litisoft-announcement (sets
//   users.litisoft_announcement_seen_at = NOW()).
// We only render when:
//   - user is loaded
//   - user has "abogado" role
//   - litisoft_announcement_seen_at is null
//
// Grandfather strategy (env LITISOFT_GATE_DEPLOYED_AT) is mentioned
// here so abogados understand only NEW cases gate them.

import React, { useEffect, useState } from "react";
import CenteredModal from "./CenteredModal";
import { auth as authApi } from "../api/endpoints";

function userIsAbogado(user) {
  if (!user) return false;
  const roles = user.roles || (user.role ? [user.role] : []);
  return roles.includes("abogado");
}

export default function LitisoftAnnouncementModal({ user, onDismissed }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user) return;
    if (!userIsAbogado(user)) return;
    if (user.litisoft_announcement_seen_at) return;
    setOpen(true);
  }, [user]);

  async function dismiss() {
    setBusy(true);
    try {
      await authApi.dismissLitisoftAnnouncement();
      setOpen(false);
      onDismissed?.();
    } catch (_e) {
      // If dismissal fails, close anyway — the modal is informational.
      setOpen(false);
    } finally {
      setBusy(false);
    }
  }

  if (!open) return null;

  return (
    <CenteredModal
      open={open}
      onClose={busy ? undefined : dismiss}
      title="Nueva política de campos LITISOFT"
      size="md"
      footer={<>
        <button onClick={dismiss} disabled={busy}>Entendido</button>
      </>}
    >
      <div style={{ fontSize: 13, color: "var(--text-body)", lineHeight: 1.5 }}>
        <p style={{ marginTop: 0 }}>
          A partir de hoy, <strong>3 nuevos campos</strong> son obligatorios antes
          de marcar un caso como contestado:
        </p>
        <ul style={{ margin: "4px 0 8px 0", paddingLeft: 18 }}>
          <li><strong>Pretensión</strong></li>
          <li><strong>Calidad de Parte Previsora</strong></li>
          <li><strong>Tipo de Notificación</strong></li>
        </ul>
        <p>
          <strong>¿Por qué?</strong> Estos 3 campos se exportan al sistema LITISOFT
          de Previsora y son requeridos por la entidad.
        </p>
        <p style={{ marginBottom: 0 }}>
          <strong>¿Qué cambia para usted?</strong> Estos 3 campos ahora aparecen
          directamente en el detalle de cada caso, en la sección{" "}
          <strong>“Datos LITISOFT obligatorios”</strong>. Los llena ahí cuando esté
          trabajando el caso. Si intenta contestar sin llenarlos, le aparecerá un
          aviso indicando qué falta.
        </p>
      </div>
    </CenteredModal>
  );
}
